import { render } from "./AdminDatasetEdit.vue?vue&type=template&id=3d97ad70"
import script from "./AdminDatasetEdit.vue?vue&type=script&lang=js"
export * from "./AdminDatasetEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__